import React, { useEffect } from "react";
import ModeOfArrival from "./ModeOfArrival/ModeOfArrival";
import { Divider } from "antd";
import Informant from "./Informant/Informant";
import ChiefComplaints from "./ChiefComplaints/ChiefComplaints";
import PresentIllness from "./PresentIllness/PresentIllness";
import TreatmentHistory from "./TreatmentHistory/TreatmentHistory";
import PastMedicalHistory from "./PastMedicalHistory/PastMedicalHistory";
import "./HistoryForm.css";
import PastSurgicalHistory from "./PastSurgicalHistory/PastSurgicalHistory";
import PersonalHistory from "./PersonalHistory/PersonalHistory";
import FunctionalCapacity from "./FunctionalCapacity/FunctionalCapacity";
import KnownAllergies from "./KnownAllergies/KnownAllergies";
import { NurseInitialContext } from "./NurseInitialAssessmentFormProvider";
import { getDoctorInspectionAPI } from "../../../../services/doctor.services";

const NurseHistoryForm = ({ form, formData, patientData, editId }) => {
  useEffect(() => {
    const fetchDoctorHistoryData = async () => {
      try {
        if (!editId && patientData?.doctor_intial_assessment) {
          const doctorData = await getDoctorInspectionAPI(
            patientData?.doctor_intial_assessment
          );
          const history = doctorData?.data?.data?.history || {};
          form.setFieldsValue(history);
        } else {
          form.setFieldsValue(formData?.history || {});
        }
      } catch (error) {
        console.log(`Error:${error}`);
      }
    };

    fetchDoctorHistoryData();
  }, [form, formData, editId, patientData]);
  return (
    <>
      <ModeOfArrival form={form} />
      <Divider />
      <Informant context={NurseInitialContext} form={form} />
      <Divider />
      <ChiefComplaints context={NurseInitialContext} form={form} />
      <Divider />
      <PresentIllness context={NurseInitialContext} form={form} />
      <Divider />
      <TreatmentHistory context={NurseInitialContext} form={form} />
      <Divider />
      <PastMedicalHistory context={NurseInitialContext} form={form} />
      <Divider />
      <PastSurgicalHistory context={NurseInitialContext} form={form} />
      <Divider />
      <PersonalHistory form={form} />
      <Divider />
      <FunctionalCapacity form={form} />
      <Divider />
      <KnownAllergies context={NurseInitialContext} form={form} />
    </>
  );
};

export default NurseHistoryForm;
